<template>
    <div class="box">
      <div class="title">中大網上認知測試</div>
      <div class="sub-title text-gray">請在安靜的環境下進行</div>
    </div>
</template>

<script>

export default {
  name: "PrepareTips",
  components: {
  }
}
</script>

<style scoped>
  .box{
    text-align: center;
  }
  .title{
    font-size: var(--ecs-font-lg);
    color: #61005f;
    margin-top: 20vh;
  }
  .sub-title{
    font-size: var(--ecs-font-md);
    margin: 3.2vh auto;
  }
</style>
